import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, LifeBuoy } from 'lucide-react';
const manuals = [{
  label: 'Manual 1',
  icon: BookOpen,
  title: 'Horse Riding Instructor Master Theory Manual',
  intro: 'The six volumes tell you what to teach. This manual helps you understand why you teach it that way.',
  covers: 'Covers: teaching principles, building progressions, planning objectives, observing the rider, selecting exercises, adapting difficulty, clear communication, brief instruction techniques, safety during teaching, the difference between demonstrating, explaining and correcting, managing lesson rhythm, organizing individual and group sessions, progression criteria, repetition criteria, learning evaluation, horse welfare within planning, and professional instructor boundaries.',
  benefit: 'Stop applying exercises without understanding their purpose. Start connecting every lesson to the next with intention.'
}, {
  label: 'Manual 2',
  icon: LifeBuoy,
  title: 'Horse Riding Instructor Corrections, Adaptations & Teaching Solutions Library',
  intro: 'For the moments when the lesson does not go exactly as planned. While Manual 1 explains the methodology, this library gives you practical solutions for real teaching problems.',
  covers: 'Covers: common position errors, rider imbalance, stiff or unsteady hands, displaced legs, excessive rein use, rhythm difficulties, transition problems, loss of direction, body tension, posting trot difficulties, pole approach problems, comprehension failures, exercises that are too difficult, alternative ways to explain a skill, adaptations for different levels, easier and harder progressions, criteria for stopping or modifying a task, and solutions for groups with mixed abilities.',
  benefit: 'Never abandon your plan when a difficulty appears. Consult a correction, an adaptation, or a suitable alternative — and continue.'
}];
export function ManualsSection() {
  return <section className="py-24 px-4 bg-cream border-y border-gold-aged/30" data-id="element-172" data-mp="29kwqk7x3m6uo">
      <div className="max-w-5xl mx-auto" data-id="element-173" data-mp="24md486elet1s">
        <div className="text-center mb-16" data-id="element-174" data-mp="24phenlinil0w">
          <p className="text-gold-aged font-bold tracking-widest uppercase mb-2" data-id="element-175" data-mp="2jkxey89trd5q">
            Included in the complete 6-in-1 system
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest" data-id="element-176" data-mp="2emcgoee4v3jx">
            The 2 Professional Instructor Manuals
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-177" data-mp="1lxopk26pdjyg">
          {manuals.map((manual, index) => {
          const Icon = manual.icon;
          return <motion.div key={manual.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white border border-gold-aged/40 rounded-2xl p-8 relative shadow-[0_4px_20px_rgba(18,53,36,0.06)] flex flex-col" data-id="element-178" data-mp="20nmdqi4mu9nn" data-mpi={index}>
                <div className="absolute top-0 right-0 bg-forest text-ivory px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-179" data-mp="3jk7ngc9ow8u4">
                  {manual.label}
                </div>

                <div className="w-12 h-12 bg-leather rounded-full flex items-center justify-center text-forest mb-6" data-id="element-180" data-mp="39uo475i2ecyq">
                  <Icon size={24} data-id="element-181" data-mp="1ecvc546z7f1" />
                </div>

                <h3 className="text-xl font-serif font-bold mb-3 pr-20 text-forest" data-id="element-182" data-mp="1crvbzz3yw9s">
                  {manual.title}
                </h3>

                <p className="text-ink text-sm mb-4 leading-relaxed font-medium" data-id="element-183" data-mp="3ok3rucmau2a7">
                  {manual.intro}
                </p>

                <p className="text-warmgray text-sm mb-6 leading-relaxed flex-grow" data-id="element-184" data-mp="3sjkyvahdj7hh">
                  {manual.covers}
                </p>

                <p className="text-pine text-sm italic font-medium" data-id="element-185" data-mp="2h60p5rnwsjtm">
                  {manual.benefit}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}